/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type SharepointSiteData = {
  id: string;
  name: string;
  displayName: string;
};

/** @internal */
export const SharepointSiteData$inboundSchema: z.ZodType<
  SharepointSiteData,
  z.ZodTypeDef,
  unknown
> = z.object({
  id: z.string(),
  name: z.string(),
  display_name: z.string(),
}).transform((v) => {
  return remap$(v, {
    "display_name": "displayName",
  });
});
/** @internal */
export type SharepointSiteData$Outbound = {
  id: string;
  name: string;
  display_name: string;
};

/** @internal */
export const SharepointSiteData$outboundSchema: z.ZodType<
  SharepointSiteData$Outbound,
  z.ZodTypeDef,
  SharepointSiteData
> = z.object({
  id: z.string(),
  name: z.string(),
  displayName: z.string(),
}).transform((v) => {
  return remap$(v, {
    displayName: "display_name",
  });
});

export function sharepointSiteDataToJSON(
  sharepointSiteData: SharepointSiteData,
): string {
  return JSON.stringify(
    SharepointSiteData$outboundSchema.parse(sharepointSiteData),
  );
}
export function sharepointSiteDataFromJSON(
  jsonString: string,
): SafeParseResult<SharepointSiteData, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => SharepointSiteData$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'SharepointSiteData' from JSON`,
  );
}
